/**
 * Mapa estático ícone-string -> componente Lucide para categorias.
 * Mantém o mesmo conjunto disponível no painel admin (Admin.jsx) — assim o
 * que o admin escolhe é exatamente o que aparece no site público. Pré-importar
 * permite tree-shaking previsível pelo CRA.
 */
import {
  Tag, Camera, BookOpen, Briefcase, HeartPulse, Scissors, Music, Palette,
  Code, Wrench, PartyPopper, ChefHat, Dumbbell, GraduationCap, Stethoscope,
  Scale, Sparkles, Leaf, PaintBucket, Hammer, Car, Home, Gamepad2, Video,
  Mic, ShoppingBag, Globe, Users, Baby, Dog, Cat, Shield, Flame, Star, Sun,
  Moon, Headphones, Monitor, Smartphone, Calculator, Clipboard,
  type LucideProps,
} from "lucide-react";
import type { ComponentType } from "react";

type IconComponent = ComponentType<LucideProps>;

export const CATEGORY_ICON_MAP: Record<string, IconComponent> = {
  "tag": Tag,
  "camera": Camera,
  "book-open": BookOpen,
  "briefcase": Briefcase,
  "heart-pulse": HeartPulse,
  "scissors": Scissors,
  "music": Music,
  "palette": Palette,
  "code": Code,
  "wrench": Wrench,
  "party-popper": PartyPopper,
  "chef-hat": ChefHat,
  "dumbbell": Dumbbell,
  "graduation-cap": GraduationCap,
  "stethoscope": Stethoscope,
  "scale": Scale,
  "sparkles": Sparkles,
  "leaf": Leaf,
  "paint-bucket": PaintBucket,
  "hammer": Hammer,
  "car": Car,
  "home": Home,
  "gamepad-2": Gamepad2,
  "video": Video,
  "mic": Mic,
  "shopping-bag": ShoppingBag,
  "globe": Globe,
  "users": Users,
  "baby": Baby,
  "dog": Dog,
  "cat": Cat,
  "shield": Shield,
  "flame": Flame,
  "star": Star,
  "sun": Sun,
  "moon": Moon,
  "headphones": Headphones,
  "monitor": Monitor,
  "smartphone": Smartphone,
  "calculator": Calculator,
  "clipboard": Clipboard,
};

export const CATEGORY_ICON_OPTIONS = Object.keys(CATEGORY_ICON_MAP);

/** Componente que renderiza o ícone Lucide referente ao slug informado.
 * Cai pra Sparkles quando o slug não está mapeado (mantém algo bonito sempre). */
export function CategoryIcon({
  name,
  className = "w-5 h-5",
  ...rest
}: {
  name?: string;
  className?: string;
} & Omit<LucideProps, "ref">) {
  const Component = CATEGORY_ICON_MAP[name || ""] || Sparkles;
  return <Component className={className} {...rest} />;
}